import { motion } from 'framer-motion'

const CertificateCard = ({ icon: Icon, image, title, description, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.15 }}
      whileHover={{ y: -8 }}
      className="group h-full"
    >
      <div
        className="relative bg-white rounded-3xl shadow-lg overflow-hidden border border-gray-100 
                    hover:shadow-2xl hover:border-primary-200 transition-all duration-300 h-full flex flex-col"
      >
        {/* Content */}
        <div className="p-6 flex flex-col flex-1">
          {/* Icon Badge */}
          <div className="flex items-center gap-4 mb-4">
            <div
              className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-50 to-primary-100 
                          flex items-center justify-center flex-shrink-0 
                          group-hover:from-primary-100 group-hover:to-primary-200 
                          transition-colors duration-300 ring-1 ring-primary-200/50"
              aria-hidden="true"
            >
              {Icon ? (
                <Icon className="h-6 w-6 text-primary-600" />
              ) : image ? (
                <img src={image} alt={title} className="h-8 w-8 object-contain" />
              ) : null}
            </div>
            <h3 className="text-lg font-bold text-gray-900 group-hover:text-primary-600 transition-colors leading-tight">
              {title}
            </h3>
          </div>

          {/* Description */}
          {description && (
            <p className="text-gray-500 text-sm leading-relaxed mt-auto">
              {description}
            </p>
          )}
        </div>

        {/* Bottom accent bar */}
        <div className="h-1 w-full bg-gradient-to-r from-primary-500 via-secondary-500 to-primary-500 
                        scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
      </div>
    </motion.div>
  )
}

export default CertificateCard
